import React, { Children } from 'react';
import SideBar from '../HomeComponents/SideBar';
import NavBar from '../NavBar/NavBar';

const Layout = ({ children }) => {
    return (
        <>
            <NavBar></NavBar>
            <SideBar></SideBar>
            <div className="lg:pl-[14rem] mt-[5.8125rem]">
                {children}
            </div>

        </>
    );
};

export default Layout;